import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Card, Grid,} from "@mui/material";
import "./pricing.css"
import {useTranslation} from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Pricing = () => {
  const {t} = useTranslation();
  const [expanded, setExpanded] = React.useState('accordion-3');

  const accordions = [
    {
      id: "accordion-3",
      summary: t("pricing.accordion.3.summary"),
      details: [
        {
          title: t("pricing.accordion.3.details.title.1"),
          text: t("pricing.accordion.3.details.text.1")
        },
        {
          title: t("pricing.accordion.3.details.title.2"),
          text: t("pricing.accordion.3.details.text.2")
        },
        {
          title: t("pricing.accordion.3.details.title.3"),
          text: t("pricing.accordion.3.details.text.3")
        },
      ]
    }
  ]

  const cardContent = [
    {
      language: t("pricing.card.camp.content.language.1"),
      period: t("pricing.card.camp.content.period.1"),
    },
    {
      language: t("pricing.card.camp.content.language.2"),
      period: t("pricing.card.camp.content.period.2"),
    },
    {
      language: t("pricing.card.camp.content.language.3"),
      period: t("pricing.card.camp.content.period.3"),
    },
    {
      language: t("pricing.card.camp.content.language.4"),
      period: t("pricing.card.camp.content.period.4"),
    }
  ]

  return (
    <div className="section" id="pricing">
      <div className="container">
        <Card className="card-container">
          <h1>{t("pricing.title")}</h1>
          <Grid container spacing={6}>
            <Grid item xs={12} sm={5}>
              {cardContent.map((element, i) =>
                <div key={i} className="card card-camp">
                  <Grid container>
                    <Grid item xs={12} className="card-camp-grid">
                      <Grid container columnSpacing={2}>
                        <Grid item xs={4}>
                          <p className="card-camp-label">{t("pricing.card.camp.label.language")}</p>
                        </Grid>
                        <Grid item xs={8}>
                          <p className="card-camp-content">{element.language}</p>
                        </Grid>
                        <Grid item xs={4}>
                          <p className="card-camp-label">{t("pricing.card.camp.label.period")}</p>
                        </Grid>
                        <Grid item xs={8}>
                          <p className="card-camp-content">{element.period}</p>
                        </Grid>
                        <Grid item xs={12}>
                          <p className="card-camp-label-small">{t("pricing.card.camp.label.waiting.price")}</p>
                          <p className="card-camp-label-small">{t("pricing.card.camp.label.waiting.text")}</p>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              )}
            </Grid>
            <Grid item sm={7}>
              <div className="pricing-content">
                {accordions.map((accordion, i) =>
                  <Accordion
                    key={i}
                    className="accordion card"
                    onChange={(e, expanded) =>
                      expanded ? setExpanded(accordion.id) : setExpanded(null)
                    }
                    expanded={expanded === accordion.id}
                  >
                    <AccordionSummary className="accordion-summary">
                      {accordion.summary}
                      <div className={`expand ${expanded === accordion.id ? 'rotated' : ''}`}>
                        <ExpandMoreIcon/>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails className="accordion-details">
                      {accordion.details.map((detail, j) =>
                        <div key={j}>
                          <h4>{detail.title}</h4>
                          <div className="vacations-content">
                            {detail.text}
                          </div>
                        </div>
                      )}
                    </AccordionDetails>
                  </Accordion>
                )}
              </div>
            </Grid>
          </Grid>
        </Card>
      </div>
    </div>
  )
    ;
};

export default Pricing;
